// extracted by mini-css-extract-plugin
export var csatScore = "_f1-5";
export var header = "_f1-1";
export var panelWrapper = "_f1-2";
export var postPreview = "_f1-3";
export var rightContent = "_f1-0";
export var wrappingText = "_f1-4";